let languageDict = {
    ja: {
        //サインイン画面作成画面
        'Sign in to your account': 'アカウントにサインイン',
        //'Username': 'ユーザ名',
        'Username': 'ユーザ名',
        'Enter your Username': 'ユーザ名を入力してください',
        //'Enter your Username': 'メールアドレスを入力してください',
        'Password': 'パスワード',
        'Enter your password': 'パスワードを入力してください',
        'Forgot your password?': 'パスワードを忘れた場合',
        'Forget your password?': 'パスワードを忘れた場合',
        ' Forgot your password?': 'パスワードを忘れた場合',
        'Reset password': 'パスワードのリセット',
        'No account? ': 'アカウントがない場合',
        'Create account': 'アカウント作成',
        'Sign In': 'サインイン',
        'User does not exist': 'ユーザーが存在しません。',
        'Incorrect username or password.': 'ユーザー名またはパスワードが間違っています。',
        //アカウント作成画面
        'Create a new account': '新しいアカウントを作成',
        'Email': 'Eメール',
        'Have an account? ': 'アカウントをお持ちの場合',
        'Sign in': 'サインイン',
        'Create Account': 'アカウント作成',
        'Password did not conform with policy: Password must have uppercase characters': 'パスワードがポリシーに適合していませんでした。',
        'Password did not conform with policy: Password must have symbol characters': 'パスワードがポリシーに適合していませんでした。パスワードには記号文字が必要です。',
        'User already exists': 'ユーザが既に存在します',
        //確認画面
        'Confirm Sign Up': 'サインアップ確認',
        'Confirmation Code * ': '確認コード',
        'Confirmation Code': '確認コード',
        'Lost your code? ': 'コードをお忘れですか？',
        'Resend Code': 'コードの再送',
        'Back to Sign In': 'サインイン',
        'Confirm': '登録',
        'Invalid verification code provided, please try again.': '無効な確認コードです',
    }
}

export default languageDict;
